// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardNameSelectorActions = require('actions/hireCardNameSelector');
const hireContactDataActions = require('actions/hireContactData');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const hireInformationActions = require('actions/hireInformation');
const hirePaymentMethodActions = require('actions/hirePaymentMethod');
const hireCardCreditINE = require('actions/commons/hireCardCreditINE');
const { updateConsents } = require('actions/gdprConsents');
const { setShippingAddress, resetShippingAddress } = require('actions/shippingAddress');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { resetProductInfo } = require('actions/hiringProductInformation');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
const { setTermsAndCondsInfoRevolving } = require('actions/cardRevolvingDocuments');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { getCCOfficeChannel, isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const {
  getCardStandard,
  getCreditCardHiringStatus,
  getShippingAddressDetails,
} = require('utilities/hireCardsHelper');
const { get } = require('lodash');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
  API_CHANNEL,
  CREDIT_CARD_SUBTYPE_DIAMOND,
  CREDIT_CARD_TYPE_PACK,
  THIRD_STEP,
  CREDIT_CARD_SUBTYPE_VISA,
  CREDIT_CARD_TYPE_VISA
} = require('constants/index');
const { DIAMOND_PACK_PRODUCT_ALIAS } = require('constants/hiringProductInformation');
const { NEW_SHIPPING_ADDRESS } = require('constants/shippingAddress');
const { CREDIT_CARD_REVOLVING_PROCESS, MESSAGE_HIRE_24H, NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
const { formatText } = require('core/i18n').i18n;

function resetWizard() {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_RESET,
  };
}

function onHandleChangeCheckBoxCC() {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_SET_AGREEMENT_CHECKBOX_CC
  };
}

const reset = () => dispatch => {
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(hireCardNameSelectorActions.reset());
  dispatch(hireCreditLimitActions.reset());
  dispatch(hireInformationActions.reset());
  dispatch(hirePaymentMethodActions.reset());
  dispatch(hireContactDataActions.reset());
  dispatch(resetShippingAddress());
  dispatch(resetWizard());
  dispatch(resetPreContractualInfo());
  dispatch(resetProductInfo());
};

function setAccount(accountId) {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_SET_ACCOUNT,
    payload: {
      accountId,
    },
  };
}

const setAgreementCheckbox = (evt, stepToUpdate = undefined) => {
  const { checked } = evt.target;
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_SET_AGREEMENT_CHECKBOX,
    payload: {
      checked,
      stepToUpdate,
    },
  };
};

function setVisibleStep(step) {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_SET_VISIBLE_STEP,
    payload: {
      step,
    },
  };
}

function processEmailSuccess() {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_PROCCESS_EMAIL_SUCCESS,
  };
}
function processEmailError() {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_PROCCESS_EMAIL_ERROR,
  };
}

function validateAccount() {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_VALIDATE_ACCOUNT,
  };
}

function validateLoading(loadingFlag) {
  return {
    type: actionTypes.HIRE_CARD_LOADING,
    payload: {
      loadingFlag,
    },
  };
}

function validate(step, externalComponentsAreValid, isRevolving = false) {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_VALIDATE_STEP,
    payload: {
      step,
      valid: externalComponentsAreValid,
      isRevolving,
    },
  };
}


function newValidate(step, externalComponentsAreValid, isRevolving = false) {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_NEW_VALIDATE_STEP,
    payload: {
      step,
      valid: externalComponentsAreValid,
      isRevolving,
    },
  };
}

function hireCardDiamondPackPrintDocument() {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_PRINT_DOCUMENT,

  };
}

function hireCardDiamondPackPrintDocumentPolicy() {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_PRINT_DOCUMENT_POLICY,
  };
}

function hireCardDiamondPackCheckedRadioButton(check) {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_CHECK_RADIO_BUTTON,
    payload: {
      check,
    },
  };
}

function hireCardDiamondPackCheckedRadioButtonPolicy(check) {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_CHECK_RADIO_BUTTON_POLICY,
    payload: {
      check,
    },
  };
}

function agreeIneCheckbox() {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_AGREEINECHECKBOX,
  };
}

const validateFirstAndFifthStep = step => (dispatch, getState) => {
  const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
  dispatch(validate(step, true, showIneAndRevolving));
};

const validateSecondStep = step => (dispatch, getState) => {
  const immHireCardImageSelector = getState().hireCardImageSelector;
  const externalComponentsAreValid = immHireCardImageSelector.get('valid');
  dispatch(validate(step, externalComponentsAreValid));
};

const validateThirdStep = step => (dispatch, getState) => {
  const immHirePaymentMethod = getState().hirePaymentMethod;
  const immHireCreditLimit = getState().hireCreditLimit;
  const accountIsValid = getState().hireCardDiamondPack.getIn([
    'steps',
    step - 1,
    'accountIsValid',
  ]);

  let allComponentsAreValid =
    immHirePaymentMethod.get('valid') && immHireCreditLimit.get('valid') && accountIsValid;

  if (
    allComponentsAreValid &&
    immHireCreditLimit.get('maxValueToAuthorize') > 0 &&
    immHireCreditLimit.get('creditLimit') > immHireCreditLimit.get('maxValueToAuthorize') &&
    immHireCreditLimit.get('minValue') <= immHireCreditLimit.get('maxValueToAuthorize')
  ) {
    dispatch(hireCreditLimitActions.toggleModal(true));
  } else {
    dispatch(validate(step, allComponentsAreValid));
  }
};

const validateFourthStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;

  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');

    dispatch(validate(step, allComponentsAreValid));

    if (step == 4) {
      dispatch(validate(step, allComponentsAreValid));
    } else {
      __CONTACT_CENTER__ && !isPrintOfficeMode() ? dispatch(validate(step, allComponentsAreValid)) : dispatch(newValidate(step, allComponentsAreValid));
    }
    //Set shipping address as new correspondance address
    allComponentsAreValid && dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
  } else {
    if (step == 4) {
      dispatch(validate(step, allComponentsAreValid));
    } else {
      __CONTACT_CENTER__ && !isPrintOfficeMode() ? dispatch(validate(step, allComponentsAreValid)) : dispatch(newValidate(step, allComponentsAreValid));
    }
  }
};

const validateINEStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;
  const immHireCardDiamondPack = getState().hireCardDiamondPack;
  const documentINE = immHireCardDiamondPack.get('documentINE');
  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');
    dispatch(validate(step, allComponentsAreValid))
    return !documentINE && dispatch(hireCardCreditINE.getInitINEstep(immHireCardDiamondPack));
  } else {
    dispatch(validate(step, allComponentsAreValid))
    return !documentINE && dispatch(hireCardCreditINE.getInitINEstep(immHireCardDiamondPack));
  }
};

const validatePolicyStep = () => (dispatch, getState) => {
  const immHireCardDiamondPack = getState().hireCardDiamondPack;
  const documentPolicy = immHireCardDiamondPack.get('documentPolicy')
  !documentPolicy && dispatch(hireCardCreditINE.getInitPolicystep(immHireCardDiamondPack));
};

const getStep = step => (dispatch, getState) => {
  const valid = getState().hireCardDiamondPack.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};

const processEmail = () => (dispatch, getState) => {
  const productType = getState().hireCreditLimit.get('productType');
  const productSubType = getState().hireCreditLimit.get('productSubType');
  const standard = getState().hireCreditLimit.get('referenceStandard');
  const immHireCardDiamondPack = getState().hireCardDiamondPack
  const documentId = immHireCardDiamondPack.get('documentId')
  const operationProcessIdInit = immHireCardDiamondPack.get('operationProcessIdInit')
  const scrollDown = immHireCardDiamondPack.get('scrollDown')
  const acceptanceText = isPrintOfficeMode() ? formatText('hireCardOpenCreditStepINE-acceptanceTextOffice') :
    !__CONTACT_CENTER__ && !isPrintOfficeMode ? formatText('hireCardOpenCreditStepINE-labelCheckbox') : formatText('hireCardOpenCredit-step4NewCheckboxText')

  const params = {
    query: {

      product: {
        type: productType,
        subtype: productSubType,
        standard: standard
      },
      contactCenter: false,
      sendInsuranceDocument: true,
      sendRelevantRevolvingDocument: false,
      documentId,
      contractNumber: 0,
      mailType: "precontractual",
      operationProcessId: operationProcessIdInit,
      acceptanceText,
      scrollDown,
    }
  };
  APIPost({
    dispatch,
    endpoint: 'hiringCardsSimple',
    params
  })
    .then(() => {
      dispatch(processEmailSuccess());
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(processEmailError());

      }
    });

};
const validateStep = step => (dispatch, getState) => {
  const cardsFeatureFlag = getState().flagBasedFeatures
  const newCardsFF = cardsFeatureFlag.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES)
  if (newCardsFF) {
    if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
      if (step === 1 && cardsFeatureFlag.get(MESSAGE_HIRE_24H)) {
        const immCards = getState().cards;
        const immCardById = immCards && immCards.get('byId');
        const immCardByOrder = immCards && immCards.get('byOrder');

        const cardObj =
          immCardByOrder &&
          immCardByOrder.map(cardId => {
            const immCard = immCardById && immCardById.get(cardId);
            return {
              contractNumber: immCard.getIn(['contract', 'number']),
              pan: immCard.get('number'),
              product: immCard.get('newProduct'),
              subType: immCard.get('productSubType'),
              standard: immCard.getIn(['product', 'standard']),
            };
          });
        dispatch(validateLoading(true));
        return APIPost({
          dispatch,
          endpoint: 'validateCardHire',
          params: {
            query: { cards: cardObj },
          },
        })
          .then(() => {
            dispatch(validateLoading(false));
            dispatch(validate(step, false));
          })
          .catch(error => {
            if (error) {
              if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
                dispatch(validate(step, true));
                dispatch(validateLoading(false));
              } else {
                dispatch(hireCardDiamondPackFailure());
                dispatch(validateLoading(false));
              }
            }
          });
      } else if (step === 2) {
        //SECOND_STEP
        dispatch(hireCardImageSelectorActions.validateStep());
        dispatch(validateSecondStep(step));
      } else if (step === 3) {
        //THIRD_STEP
        dispatch(validateAccount());
        dispatch(hireCreditLimitActions.validateStep());
        dispatch(hirePaymentMethodActions.validateStep());
        dispatch(validateThirdStep(step));
      } else if (step === 4) {
        //FOURTH_STEP
        dispatch(validateINEStep(step))
          .then(() => {
            dispatch(validatePolicyStep());
          })
      } else if (step === 1 || step === 5) {
        //FIRST_STEP AND FIFTH_STEP
        dispatch(validateFirstAndFifthStep(step));
      } else {
        dispatch(validateLoading(false));
        dispatch(validate(step, false));
      }
      return dispatch(getStep(step));

    } else {

      if (step === 1 && cardsFeatureFlag.get(MESSAGE_HIRE_24H)) {
        const immCards = getState().cards;
        const immCardById = immCards && immCards.get('byId');
        const immCardByOrder = immCards && immCards.get('byOrder');

        const cardObj =
          immCardByOrder &&
          immCardByOrder.map(cardId => {
            const immCard = immCardById && immCardById.get(cardId);
            return {
              contractNumber: immCard.getIn(['contract', 'number']),
              pan: immCard.get('number'),
              product: immCard.get('newProduct'),
              subType: immCard.get('productSubType'),
              standard: immCard.getIn(['product', 'standard']),
            };
          });
        dispatch(validateLoading(true));
        return APIPost({
          dispatch,
          endpoint: 'validateCardHire',
          params: {
            query: { cards: cardObj },
          },
        })
          .then(() => {
            dispatch(validateLoading(false));
            dispatch(validate(step, false));
          })
          .catch(error => {
            if (error) {
              if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
                dispatch(validate(step, true));
                dispatch(validateLoading(false));
              } else {
                dispatch(hireCardDiamondPackFailure());
                dispatch(validateLoading(false));
              }
            }
          });
      } else if (step === 2) {
        dispatch(hireCardImageSelectorActions.validateStep());
        dispatch(validateSecondStep(step));
      } else if (step === 3) {
        dispatch(validateAccount());
        dispatch(hireCreditLimitActions.validateStep());
        dispatch(hirePaymentMethodActions.validateStep());
        dispatch(validateThirdStep(step));
      } else if (step === 4) {
        dispatch(validateINEStep(step));
      } else if (step === 5) {
        dispatch(validatePolicyStep());
        dispatch(processEmail());
        dispatch(validateFourthStep(step));
        !isPrintOfficeMode() && dispatch(agreeIneCheckbox())
      } else if (step === 1 || step === 6) {
        dispatch(validateFirstAndFifthStep(step));
      } else {
        dispatch(validateLoading(false));
        dispatch(validate(step, false));
      }
      return dispatch(getStep(step));
    }
  } else {
    if (step === 1 && cardsFeatureFlag.get(MESSAGE_HIRE_24H)) {
      const immCards = getState().cards;
      const immCardById = immCards && immCards.get('byId');
      const immCardByOrder = immCards && immCards.get('byOrder');

      const cardObj =
        immCardByOrder &&
        immCardByOrder.map(cardId => {
          const immCard = immCardById && immCardById.get(cardId);
          return {
            contractNumber: immCard.getIn(['contract', 'number']),
            pan: immCard.get('number'),
            product: immCard.get('newProduct'),
            subType: immCard.get('productSubType'),
            standard: immCard.getIn(['product', 'standard']),
          };
        });
      dispatch(validateLoading(true));
      return APIPost({
        dispatch,
        endpoint: 'validateCardHire',
        params: {
          query: { cards: cardObj },
        },
      })
        .then(() => {
          dispatch(validateLoading(false));
          dispatch(validate(step, false));
        })
        .catch(error => {
          if (error) {
            if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
              dispatch(validate(step, true));
              dispatch(validateLoading(false));
            } else {
              dispatch(hireCardDiamondPackFailure());
              dispatch(validateLoading(false));
            }
          }
        });
    } else if (step === 2) {
      //SECOND_STEP
      dispatch(hireCardImageSelectorActions.validateStep());
      dispatch(validateSecondStep(step));
    } else if (step === 3) {
      //THIRD_STEP
      dispatch(validateAccount());
      dispatch(hireCreditLimitActions.validateStep());
      dispatch(hirePaymentMethodActions.validateStep());
      dispatch(validateThirdStep(step));
    } else if (step === 4) {
      //FOURTH_STEP
      dispatch(validateFourthStep(step));
    } else if (step === 1 || step === 5) {
      //FIRST_STEP AND FIFTH_STEP
      dispatch(validateFirstAndFifthStep(step));
    } else {
      dispatch(validateLoading(false));
      dispatch(validate(step, false));
    }
    return dispatch(getStep(step));
  }
};

const setCardHire = (dispatch, data, termsAndsCondsHiringData, showIneAndRevolving) => {
  const requestData = {
    query: data,
  };

  dispatch(hireCardDiamondPackRequest());
  return APIPost({
    dispatch,
    endpoint: 'myCardsTarjetasHire',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardDiamondPackFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireCardDiamondPackSuccess(status.hiringStatus));
        const contractNumber = get(response, ['contratoTarjetaAltOnline', 'numeroContrato'], null);
        if (showIneAndRevolving && contractNumber) {
          dispatch(
            setTermsAndCondsInfoRevolving(
              OPEN_CREDIT_CARD_PRODUCT_ALIAS,
              termsAndsCondsHiringData,
              contractNumber
            )
          );
        } else {
          dispatch(setTermsAndCondsInfo(OPEN_CREDIT_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData));
        }
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardDiamondPackFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardDiamondPackFailure());
      } else {
        throw response;
      }
    });
};

const myCardsTarjetasHire = () => (dispatch, getState) => {
  const immHireCardDiamondPack = getState().hireCardDiamondPack;
  const callback = (dispatch, getState, dataToken) => {

    const contractNumberAccount = immHireCardDiamondPack.get('contractNumberAccount')
    const immCreditLimit = getState().hireCreditLimit;
    const immPaymentMethod = getState().hirePaymentMethod;
    const cardDesignKey = getCardStandard(getState().hireCardImageSelector.get('selectedImageId'));
    const email = PersonalDataHelper.getEmail(getState().profile);
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    let addressDetails,
      numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      addressDetails = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }
    const acceptanceText = __CONTACT_CENTER__ && !isPrintOfficeMode() ? 'NA' : formatText('hireCardOpenCreditHeaderPolicy-header')

    const data = {
      processType: 'contract',
      documentId: immHireCardDiamondPack.get('documentIdPolicy'),
      operationProcessId: immHireCardDiamondPack.get('operationProcessIdInitPolicy'),
      addressDetails: addressDetails,
      cardDetails: {
        cuentaCargo: contractNumberAccount,
        email,
        importeCuotaFormaPago: immPaymentMethod.get('value'),
        limiteSolicitado: immCreditLimit.get('creditLimit'),
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
        tarjetaRef: {
          canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
          standard: cardDesignKey,
          subTipo: CREDIT_CARD_SUBTYPE_DIAMOND,
          tipo: CREDIT_CARD_TYPE_PACK,
        },
        tipoFormaPago: immPaymentMethod.get('type'),
      },
      deliverToProvidedDetails: true,
      numDomicilio,
      dataToken,
      acceptanceText,
      scrollDown: immHireCardDiamondPack.get('scrollDownPolicy'),
    };

    const termsAndsCondsHiringData = [
      {
        standard: cardDesignKey,
        subType: CREDIT_CARD_SUBTYPE_DIAMOND,
        type: CREDIT_CARD_TYPE_PACK,
      },
    ];
    dispatch(updateConsents(dataToken))
      .then(() => {
        setCardHire(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving)
      }
      )
      .catch(response => {
        if (!!response.error) {
          setCardDiamondPack(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });

};

function setWillCancel(willCancel) {
  return {
    type: actionTypes.HIRE_CARD_DIAMOND_PACK_WILL_CANCEL,
    payload: {
      willCancel,
    },
  };
}


const checkRadioButton = (check) => (dispatch, getState) => {
  dispatch(hireCardDiamondPackCheckedRadioButton(check));
}

const checkRadioButtonPolicy = (check) => (dispatch, getState) => {
  dispatch(hireCardDiamondPackCheckedRadioButtonPolicy(check));
}

const printDocument = () => (dispatch, getState) => {
  dispatch(hireCardDiamondPackPrintDocument());
}

const printDocumentPolicy = () => (dispatch, getState) => {
  dispatch(hireCardDiamondPackPrintDocumentPolicy());
}


const hireCardDiamondPackRequest = () => ({
  type: actionTypes.HIRE_CARD_DIAMOND_PACK_REQUEST,
});

const hireCardDiamondPackSuccess = hiringStatus => ({
  type: actionTypes.HIRE_CARD_DIAMOND_PACK_SUCCESS,
  payload: {
    hiringStatus,
  },
});

const hireCardDiamondPackFailure = (hiringStatus = '', errorMsg = '') => ({
  type: actionTypes.HIRE_CARD_DIAMOND_PACK_FAILURE,
  payload: {
    errorMsg,
    hiringStatus,
  },
});

const setAllAccountsToInactive = () => ({
  type: actionTypes.HIRE_CARD_DIAMOND_PACK_SET_ALL_ACCOUNTS_TO_INACTIVE,
});

const setCardDiamondPack = (dispatch, data, termsAndsCondsHiringData, showIneAndRevolving) => {
  const requestData = {
    header: {
      version: 2,
    },
    query: data,
  };

  dispatch(hireCardDiamondPackRequest());
  return APIPost({
    dispatch,
    endpoint: 'hireCreditCard',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardDiamondPackFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireCardDiamondPackSuccess(status.hiringStatus));
        const contractNumber = get(response, ['contratoTarjetaAltOnline', 'numeroContrato'], null);
        if (showIneAndRevolving && contractNumber) {
          dispatch(
            setTermsAndCondsInfoRevolving(
              DIAMOND_PACK_PRODUCT_ALIAS,
              termsAndsCondsHiringData,
              contractNumber
            )
          );
        } else {
          dispatch(setTermsAndCondsInfo(DIAMOND_PACK_PRODUCT_ALIAS, termsAndsCondsHiringData));
        }
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardDiamondPackFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardDiamondPackFailure());
      } else {
        throw response;
      }
    });
};

const hireCardDiamondPack = () => (dispatch, getState) => {
  const callback = (dispatch, getState, dataToken) => {
    const accountId = getState().hireCardDiamondPack.getIn(['steps', THIRD_STEP, 'accountId']);
    const accountInfo = getState().accounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']);
    const immCreditLimit = getState().hireCreditLimit;
    const immPaymentMethod = getState().hirePaymentMethod;
    const cardDesignKey = getCardStandard(getState().hireCardImageSelector.get('selectedImageId'));
    const email = PersonalDataHelper.getEmail(getState().profile);
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    let addressDetails,
      numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      addressDetails = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }

    const data = {
      addressDetails: addressDetails,
      cardDetails: {
        cuentaCargo: accountInfo,
        email,
        importeCuotaFormaPago: immPaymentMethod.get('value'),
        limiteSolicitado: immCreditLimit.get('creditLimit'),
        // todo nombreAdicional value
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
        tarjetaRef: {
          canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
          standard: cardDesignKey,
          subTipo: CREDIT_CARD_SUBTYPE_DIAMOND,
          tipo: CREDIT_CARD_TYPE_PACK,
        },
        tipoFormaPago: immPaymentMethod.get('type'),
      },
      deliverToProvidedDetails: true,
      numDomicilio,
      dataToken,
    };

    const termsAndsCondsHiringData = [
      {
        standard: cardDesignKey,
        subType: CREDIT_CARD_SUBTYPE_DIAMOND,
        type: CREDIT_CARD_TYPE_PACK,
      },
    ];

    dispatch(updateConsents(dataToken))
      .then(() => setCardDiamondPack(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving))
      .catch(response => {
        if (!!response.error) {
          setCardDiamondPack(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

module.exports = {
  hireCardDiamondPack,
  reset,
  setAccount,
  setAgreementCheckbox,
  setAllAccountsToInactive,
  setVisibleStep,
  setWillCancel,
  validate,
  validateStep,
  checkRadioButton,
  printDocument,
  processEmail,
  onHandleChangeCheckBoxCC,
  myCardsTarjetasHire,
  printDocumentPolicy,
  checkRadioButtonPolicy
};
